/* eslint-disable no-console */
/* eslint-disable no-empty */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import firebase from 'firebase';
import Cookies from 'js-cookie';
import client from '../client';
import { UPDATE_FCM_TOKEN } from '../graphql-client/mutations';

const initializeFirebase = () => {
  firebase.initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  });
};
const isSupported = firebase.messaging.isSupported();

initializeFirebase();
isSupported && firebase.messaging().usePublicVapidKey(process.env.REACT_APP_FIREBASE_FIREBASE_VAPID_KEY);
const messaging = isSupported && firebase.messaging();

export const askForPermissioToReceiveNotifications = async () => {
  try {
    if (!isSupported) {
      return;
    }
    await messaging.requestPermission();
    messaging.getToken().then((token) => {
      if (token) {
        client.mutate({ mutation: UPDATE_FCM_TOKEN, variables: { token } });
      }
    }).catch((err) => {
      console.log({ err });
    });
  } catch (error) {
    console.error(error);
  }
};

export const showMessage = async () => {
  try {
    if (!firebase.messaging.isSupported) {
      return;
    }
    messaging.onMessage(async (payload) => {
      const {
        title, body, icon, click_action, tag,
      } = payload.notification || payload.data;
      if (payload.data && payload.data.type === 'chat') {
        return;
      }
      const registers = await navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope');

      registers.showNotification(title, {
        body,
        icon,
        click_action,
        tag,
        renotify: true,
        image: icon,
        data: {
          click_action: payload.notification.click_action,
        },
      });
    });
  } catch (e) {
  }
};

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    Cookies.set('uid', user.uid);
  } else {
    // User is signed out.
    // ...
  }
});

export const myFirestore = firebase.firestore();
export const storage = firebase.storage();
export const firebaseAuth = firebase.auth();
export const fieldPath = firebase.firestore.FieldPath;
export const fieldValue = firebase.firestore.FieldValue;
